import { Container, Characters } from "../components";

const PersoPage = () => {
    return (
        <Container>
            <Characters />
        </Container>
    );
};

export default PersoPage;
